/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrganizationApprovalPreviewRequest } from '../models/OrganizationApprovalPreviewRequest';
import type { SetFunctionalOwnerRequest } from '../models/SetFunctionalOwnerRequest';
import type { SetStoreManagerRequest } from '../models/SetStoreManagerRequest';
import type { SuccessResponse_CurrentStoreManagerResponse_ } from '../models/SuccessResponse_CurrentStoreManagerResponse_';
import type { SuccessResponse_EmployeeOrganizationResponse_ } from '../models/SuccessResponse_EmployeeOrganizationResponse_';
import type { SuccessResponse_FunctionalOwnerCandidateResponse_ } from '../models/SuccessResponse_FunctionalOwnerCandidateResponse_';
import type { SuccessResponse_FunctionalOwnerItem_ } from '../models/SuccessResponse_FunctionalOwnerItem_';
import type { SuccessResponse_FunctionalOwnersResponse_ } from '../models/SuccessResponse_FunctionalOwnersResponse_';
import type { SuccessResponse_ManagerCandidateResponse_ } from '../models/SuccessResponse_ManagerCandidateResponse_';
import type { SuccessResponse_ManagerStoreAssignmentItem_ } from '../models/SuccessResponse_ManagerStoreAssignmentItem_';
import type { SuccessResponse_ManagerStoreAssignmentsResponse_ } from '../models/SuccessResponse_ManagerStoreAssignmentsResponse_';
import type { SuccessResponse_OnboardingManagerCandidateResponse_ } from '../models/SuccessResponse_OnboardingManagerCandidateResponse_';
import type { SuccessResponse_OrganizationApprovalPreviewResponse_ } from '../models/SuccessResponse_OrganizationApprovalPreviewResponse_';
import type { SuccessResponse_OrganizationCompletenessResponse_ } from '../models/SuccessResponse_OrganizationCompletenessResponse_';
import type { SuccessResponse_OrganizationTreeResponse_ } from '../models/SuccessResponse_OrganizationTreeResponse_';
import type { SuccessResponse_ReportingLineItem_ } from '../models/SuccessResponse_ReportingLineItem_';
import type { UpdateReportingLineRequest } from '../models/UpdateReportingLineRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrganizationService {
    /**
     * Get Employee Organization Endpoint
     * @returns SuccessResponse_EmployeeOrganizationResponse_ Successful Response
     * @throws ApiError
     */
    public static getEmployeeOrganizationEndpointApiV1OrganizationEmployeesEmployeeIdGet({
        employeeId,
    }: {
        employeeId: number,
    }): CancelablePromise<SuccessResponse_EmployeeOrganizationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organization/employees/{employee_id}',
            path: {
                'employee_id': employeeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Preview Organization Approval Chain Endpoint
     * @returns SuccessResponse_OrganizationApprovalPreviewResponse_ Successful Response
     * @throws ApiError
     */
    public static previewOrganizationApprovalChainEndpointApiV1OrganizationApprovalPreviewPost({
        requestBody,
    }: {
        requestBody: OrganizationApprovalPreviewRequest,
    }): CancelablePromise<SuccessResponse_OrganizationApprovalPreviewResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organization/approval-preview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Manager Candidates Endpoint
     * @returns SuccessResponse_ManagerCandidateResponse_ Successful Response
     * @throws ApiError
     */
    public static listManagerCandidatesEndpointApiV1OrganizationEmployeesEmployeeIdManagerCandidatesGet({
        employeeId,
        storeContextId,
    }: {
        employeeId: number,
        storeContextId?: (number | null),
    }): CancelablePromise<SuccessResponse_ManagerCandidateResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organization/employees/{employee_id}/manager-candidates',
            path: {
                'employee_id': employeeId,
            },
            query: {
                'store_context_id': storeContextId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Reporting Line Endpoint
     * @returns SuccessResponse_ReportingLineItem_ Successful Response
     * @throws ApiError
     */
    public static updateReportingLineEndpointApiV1OrganizationEmployeesEmployeeIdManagerPut({
        employeeId,
        requestBody,
    }: {
        employeeId: number,
        requestBody: UpdateReportingLineRequest,
    }): CancelablePromise<SuccessResponse_ReportingLineItem_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organization/employees/{employee_id}/manager',
            path: {
                'employee_id': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Functional Owner Candidates Endpoint
     * @returns SuccessResponse_FunctionalOwnerCandidateResponse_ Successful Response
     * @throws ApiError
     */
    public static listFunctionalOwnerCandidatesEndpointApiV1OrganizationFunctionalOwnersFunctionKeyCandidatesGet({
        functionKey,
    }: {
        functionKey: 'owner_final' | 'finance',
    }): CancelablePromise<SuccessResponse_FunctionalOwnerCandidateResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organization/functional-owners/{function_key}/candidates',
            path: {
                'function_key': functionKey,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Organization Tree Endpoint
     * @returns SuccessResponse_OrganizationTreeResponse_ Successful Response
     * @throws ApiError
     */
    public static getOrganizationTreeEndpointApiV1OrganizationTreeGet({
        storeId,
    }: {
        storeId?: (Array<number> | null),
    }): CancelablePromise<SuccessResponse_OrganizationTreeResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organization/tree',
            query: {
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Onboarding Manager Candidates Endpoint
     * @returns SuccessResponse_OnboardingManagerCandidateResponse_ Successful Response
     * @throws ApiError
     */
    public static listOnboardingManagerCandidatesEndpointApiV1OrganizationOnboardingManagerCandidatesGet({
        position,
        storeId,
    }: {
        position: string,
        storeId: number,
    }): CancelablePromise<SuccessResponse_OnboardingManagerCandidateResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organization/onboarding-manager-candidates',
            query: {
                'position': position,
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Organization Completeness Endpoint
     * @returns SuccessResponse_OrganizationCompletenessResponse_ Successful Response
     * @throws ApiError
     */
    public static getOrganizationCompletenessEndpointApiV1OrganizationCompletenessGet(): CancelablePromise<SuccessResponse_OrganizationCompletenessResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organization/completeness',
        });
    }
    /**
     * List Functional Owners Endpoint
     * @returns SuccessResponse_FunctionalOwnersResponse_ Successful Response
     * @throws ApiError
     */
    public static listFunctionalOwnersEndpointApiV1OrganizationFunctionalOwnersGet(): CancelablePromise<SuccessResponse_FunctionalOwnersResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organization/functional-owners',
        });
    }
    /**
     * Set Functional Owner Endpoint
     * @returns SuccessResponse_FunctionalOwnerItem_ Successful Response
     * @throws ApiError
     */
    public static setFunctionalOwnerEndpointApiV1OrganizationFunctionalOwnersFunctionKeyPut({
        functionKey,
        requestBody,
    }: {
        functionKey: 'owner_final' | 'finance',
        requestBody: SetFunctionalOwnerRequest,
    }): CancelablePromise<SuccessResponse_FunctionalOwnerItem_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organization/functional-owners/{function_key}',
            path: {
                'function_key': functionKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Current Store Manager Endpoint
     * @returns SuccessResponse_CurrentStoreManagerResponse_ Successful Response
     * @throws ApiError
     */
    public static getCurrentStoreManagerEndpointApiV1OrganizationStoresStoreIdManagerGet({
        storeId,
    }: {
        storeId: number,
    }): CancelablePromise<SuccessResponse_CurrentStoreManagerResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organization/stores/{store_id}/manager',
            path: {
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Store Manager Endpoint
     * @returns SuccessResponse_ManagerStoreAssignmentItem_ Successful Response
     * @throws ApiError
     */
    public static setStoreManagerEndpointApiV1OrganizationStoresStoreIdManagerPut({
        storeId,
        requestBody,
    }: {
        storeId: number,
        requestBody: SetStoreManagerRequest,
    }): CancelablePromise<SuccessResponse_ManagerStoreAssignmentItem_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organization/stores/{store_id}/manager',
            path: {
                'store_id': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Manager Store Assignments Endpoint
     * @returns SuccessResponse_ManagerStoreAssignmentsResponse_ Successful Response
     * @throws ApiError
     */
    public static listManagerStoreAssignmentsEndpointApiV1OrganizationManagersManagerIdStoresGet({
        managerId,
    }: {
        managerId: number,
    }): CancelablePromise<SuccessResponse_ManagerStoreAssignmentsResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organization/managers/{manager_id}/stores',
            path: {
                'manager_id': managerId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
